const dimensions = { xs: 5, s: 10, m: 15, l: 20, xl: 25, xxl: 30, xxxl: 50 };

export default dimensions;
